// extracted by mini-css-extract-plugin
export var badge = "_gc-2";
export var detailsPanel = "_gc-0";
export var resultRow = "_gc-1";